import React, { useEffect, useState } from "react";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getApi } from "../../actions/structure.action";
import { useDispatch, useSelector } from "react-redux";
import isEmpty from "../../utils/is-Empty";
import "./bharee-subscription.css";
import { boosterFeatures, leadsFeatures, starterFeatures } from "../../helpers/app-constants";
import SellerAuth from "./SellerAuth";
import { useDialog } from "../../helpers/useDialog";

const BhareeSubscriptionGeneric = ({
  showHeader = true,
  showLeads = true,
  showStarter = true,
  showBooster = true,
  changePlan = false,
  onChangePlanClick,
}) => {
  const { alert, confirm, DialogModal } = useDialog();
  const dispatch = useDispatch();

  const [selectedPlan, setSelectedPlan] = useState("");
  const [plans, setPlans] = useState([]);

  const { serviceTaxDetails, subscriptionPlans } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    getApi("getServiceTaxDetails", dispatch);
    getApi("getSubscriptionPlans", dispatch);
  }, [dispatch]);

  useEffect(() => {
    // console.log("subscriptionPlans: ", subscriptionPlans);
    if (!isEmpty(subscriptionPlans?.data) && subscriptionPlans?.data?.length > 0) {
      setPlans(subscriptionPlans?.data);
      if (isEmpty(selectedPlan)) {
        setSelectedPlan(subscriptionPlans?.data[0]);
      }
    } else {
      setPlans([]);
    }
  }, [subscriptionPlans]);

  const handleChangePlanClick = async (selectedAppFeatures) => {
    const confirmHeader = (
      <>
        <i class="bi bi-check-circle-fill"></i> Confirmation
      </>
    );
    const confirmHtml = (
      <div className="text-start">
        <p>
          You are upgrading to <strong>{selectedAppFeatures.toUpperCase()}</strong>
        </p>
        <ul>
          <li>All active Live Offers will end.</li>
          <li className="text-primary">
            Buyer price of all your existing product variants will be updated as per the applied
            charges.
          </li>
          <li>Update your Base Price and create new Live Offers accordingly.</li>
        </ul>
        <p>By clicking on "OK", you are accepting the above mentioned changes.</p>
      </div>
    );
    const isConfirmed = await confirm(confirmHtml, confirmHeader);
    if (isConfirmed) {
      onChangePlanClick(selectedAppFeatures);
    }
  };

  return (
    <div style={{ backgroundColor: "#eee" }}>
      {DialogModal}
      {showHeader && (
        <Container fluid className="p-0 m-0 bharee-subscription-page">
          <div style={{ backgroundColor: "#fbb040", padding: "20px 0" }}>
            <header className="mx-auto px-4 text-center">
              <h1 className="text-black bolder" style={{ fontSize: "3.75rem" }}>
                Bharee Plans
              </h1>
              <p className="mt-4 mx-auto text-white text-xl">
                Reach retailers through Bharee.com directly for orders and enquiries with our
                tailored plans.
              </p>
            </header>
          </div>
        </Container>
      )}
      <Container className="bharee-subscription-page">
        <Row className="px-2 px-md-5 py-4 justify-content-center">
          {showLeads && (
            <Col md={4} className="p-0 m-0 mb-4 order-3 order-md-1">
              <Card className="pricing-card shadow-xl border-0 py-2 px-2 rounded-2xl mx-2">
                <Card.Title className="w-100 text-start mt-2 px-2">
                  <Row>
                    <Col md={6} xs={6}>
                      <h4>Leads</h4>
                    </Col>
                    <Col className="text-end" md={6} xs={6}>
                      <Form.Select
                        size="sm"
                        className="w-auto d-inline-block rounded"
                        value={selectedPlan?.id}
                        onChange={(e) => {
                          const planId = Number(e.target.value);
                          const planObj = plans.find((p) => p.id === planId);
                          setSelectedPlan(planObj);
                        }}
                      >
                        {plans.map((plan) => (
                          <option key={plan.id} value={plan.id}>
                            {plan.plan_title.replace("-", " ")}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                </Card.Title>
                <Card.Body className="d-flex flex-column px-2">
                  <div className="text-start w-100">
                    <div className="d-flex justify-content-start align-items-baseline gap-1">
                      <h1 className="bolder mb-0" style={{ color: "#fbb040" }}>
                        ₹{parseInt(selectedPlan?.plan_unit_amount)}
                      </h1>
                      <p className="text-muted mb-0 small">/month</p>
                    </div>

                    <p className="text-muted small mt-1">
                      GST @18% extra.{" "}
                      {selectedPlan?.plan_period?.toLowerCase() === "year"
                        ? "Billing will be done annually."
                        : ""}
                    </p>
                  </div>

                  {!changePlan ? (
                    <SellerAuth
                      buttonText={"Start My Free Trial"}
                      registerMode={true}
                      buttonClasses={"btn-danger px-4 fw-bold signup-btn w-100 btn-subscribe"}
                      appFeatures={"leads"}
                    />
                  ) : (
                    <Button
                      className="btn-danger px-4 fw-bold signup-btn w-100 btn-subscribe"
                      onClick={() => handleChangePlanClick("leads")}
                    >
                      Select
                    </Button>
                  )}

                  <div className="mt-3 text-start w-100 features">
                    {leadsFeatures.map(([label, value], index) => (
                      <p className="text-start" key={index}>
                        <i className="bi bi-check-lg text-success"></i> {label}
                        {value !== "Yes" && (
                          <>
                            : <span className="fw-bold">{value}</span>
                          </>
                        )}
                      </p>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
          {showStarter && (
            <Col md={4} className="p-0 m-0 mb-4 order-2 order-md-2">
              <Card
                className="pricing-card-std shadow-xl border-0 py-2 px-2 rounded-2xl mx-2"
                style={{ height: "760px" }}
              >
                <Card.Title className="w-100 text-start mt-2 px-2">
                  <Row>
                    <Col md={12}>
                      <h4>Starter</h4>
                    </Col>
                  </Row>
                </Card.Title>
                <Card.Body className="d-flex flex-column px-2">
                  <div className="text-start w-100">
                    <div className="d-flex justify-content-start align-items-baseline gap-1">
                      <h1 className="bolder mb-0" style={{ color: "#fbb040" }}>
                        {parseFloat(serviceTaxDetails?.data?.starterFee).toFixed(1)}%
                      </h1>
                      <p className="text-muted mb-0 small">Bharee Charges</p>
                    </div>

                    <p className="text-muted small mt-1">
                      Success-based commission. GST @18% extra.
                    </p>
                  </div>

                  {!changePlan ? (
                    <SellerAuth
                      buttonText={"Start Selling Now"}
                      registerMode={true}
                      buttonClasses={"btn-danger px-4 fw-bold signup-btn w-100 btn-subscribe"}
                      appFeatures={"starter"}
                    />
                  ) : (
                    <Button
                      className="btn-danger px-4 fw-bold signup-btn w-100 btn-subscribe"
                      onClick={() => handleChangePlanClick("starter")}
                    >
                      Select
                    </Button>
                  )}

                  <p className="fw-bold mt-2 mb-0 text-danger" style={{ fontSize: "12px" }}>
                    Note: Own Logistic Partner is mandatory to start selling
                  </p>

                  <div className="text-start w-100 features">
                    {starterFeatures.map(([label, value], index) => (
                      <p className="text-start" key={index}>
                        <i className="bi bi-check-lg text-success"></i> {label}
                        {value !== "Yes" && (
                          <>
                            : <span className="fw-bold">{value}</span>
                          </>
                        )}
                      </p>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
          {showBooster && (
            <Col md={4} className="p-0 m-0 mb-4 order-1 order-md-3">
              <Card
                className="pricing-card-std shadow-xl py-2 px-2 rounded-2xl mx-2"
                style={{
                  border: "2px solid #fbb040",
                  height: "760px",
                }}
              >
                <Card.Title className="w-100 text-start mt-2 px-2">
                  <Row>
                    <Col md={7} xs={7}>
                      <h4>Booster</h4>
                    </Col>
                    <Col className="text-center" md={5} xs={5}>
                      <div
                        className="small rounded bg-primary"
                        style={{
                          fontSize: "14px",
                          color: "white",
                          padding: "2px 6px",
                          border: "1px solid #0d6efd",
                        }}
                      >
                        Recommended
                      </div>
                    </Col>
                  </Row>
                </Card.Title>
                <Card.Body className="d-flex flex-column px-2">
                  <div className="text-start w-100">
                    <div className="d-flex justify-content-start align-items-baseline gap-1">
                      <h1 className="bolder mb-0" style={{ color: "#fbb040" }}>
                     {/* {parseFloat(serviceTaxDetails?.data?.boosterFee).toFixed(1)}% */}
                    {parseFloat(serviceTaxDetails?.data?.boosterFee || 5.5).toFixed(1)}%
                      </h1>
                      <p className="text-muted mb-0 small">Bharee Charges</p>
                    </div>

                    <p className="text-muted small mt-1">
                      Success-based commission. GST @18% extra.
                    </p>
                  </div>

                  {!changePlan ? (
                    <SellerAuth
                      buttonText={"Start Selling Now"}
                      registerMode={true}
                      buttonClasses={"btn-danger px-4 fw-bold signup-btn w-100 btn-subscribe"}
                      appFeatures={"booster"}
                    />
                  ) : (
                    <Button
                      className="btn-danger px-4 fw-bold signup-btn w-100 btn-subscribe"
                      onClick={() => handleChangePlanClick("booster")}
                    >
                      Select
                    </Button>
                  )}

                  <p className="fw-bold mt-2 mb-0 text-danger" style={{ fontSize: "12px" }}>
                    Note: Own Logistic Partner is mandatory to start selling
                  </p>

                  <div className="text-start w-100 features">
                    {boosterFeatures.map(([label, value], index) => (
                      <p className="text-start" key={index}>
                        <i className="bi bi-check-lg text-success"></i> {label}
                        {value !== "Yes" && (
                          <>
                            : <span className="fw-bold">{value}</span>
                          </>
                        )}
                      </p>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
        <Row className="px-2 px-md-5 pb-5">
          <Col xs={12}>
            <p className="p-0 m-0 text-muted">
              Note: Bharee Charges and Subscription costs are subject to 18% GST.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BhareeSubscriptionGeneric;
